import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ImageService } from '../../services/image-service/image.service';

@Component({
    selector: 'app-mm-legible-photo',
    templateUrl: './mm-legible-photo.component.html',
    styleUrls: ['./mm-legible-photo.component.scss'],
})
export class MmLegiblePhotoComponent implements OnInit {

    constructor(public imageService: ImageService,
        private modalController: ModalController) { }

    ngOnInit() { }

    touchRetakePhoto() {
        this.modalController.dismiss();
    }

    touchPhotoOk() {
        this.modalController.dismiss('photoOk');
    }

}
